export class DigitalResourceVm {
    id: number = 0;
    unitId: number;
    unit: OhiUnitVm;

    resourceTypeId: number;
    resourceType: ResourceTypeVm;

    categoryId: number;
    category: ResourceCategoryVm;
    
    title: string;
    link: string;    
    isActive: boolean = true;
    createDate: Date;
    displayOrder: number;
    isCurrent: boolean;   
}

export class DigitalResourceShortVm {
    id: number;
    title: string;
    type: string;
    category: string;
    unit: string;
    link: string;
    isActive: boolean;  
}

export class OhiUnitVm {
    id: number;
    title: string;
    code: string;
}

export class ResourceTypeVm {
    id: number;
    name: string;
    imageLink: string;
}

export class ResourceCategoryVm {
    id: number;
    idp: number;
    name: string;
    imageLink: string;
}

export class DigitalResourceLookupResponse {
    units: OhiUnitVm[];
    categories: ResourceCategoryVm[];
    types: ResourceTypeVm[]; 
}

export class DigitalResourceSaveResponse {
    code: number;
    message: string;
    resource: DigitalResourceVm;
}